export const FETCH_ALL_PARAMS = {
    page: 1,
    size: 10000,
};
